import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
// import { Form } from "react-router-dom";

const ApplyjobAsInstitute = ({ jobId, isAppliedByYou }) => {
  const sessionId = localStorage.getItem("sessionId");
  console.log("sessionId", sessionId);

  // // ..................................Apply Institute Modal...................................
  const [applyInstitute, setApplyInstitute] = useState(false);
  const handleApplyInstitute = () => setApplyInstitute(true);
  const handleCloseApplyInstitute = () => setApplyInstitute(false);
  // // .................................Apply Institute Modal...................................

  const [batchId, setBatchId] = useState(null);
  const [ClassId, setClassId] = useState(null);

  const [batchList, setBatchList] = useState([]);
  const [ClassList, setClassList] = useState([]);

  const [selectedType, setSelectedType] = useState("");
  const [checkApplied, setCheckApplied] = useState(isAppliedByYou);

  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleShow = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);
  console.log("selectedType", selectedType);

  const [isLoading, setIsLoading] = useState(false);

  const handleApplyJob = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post(`/JobAction/ApplyJobAsInstt`, {
        sessionId: sessionId,
        jobId: jobId,
        icsid: ClassId,
        icbid: batchId,
      });

      console.log("API Response:", response);
      toast.success("Job applied successfully!");
      // handleApplyJob();
      setCheckApplied(true);
      setApplyInstitute(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error("Failed to apply for the job. Please try again.");
    } finally {
      setIsLoading(false); // Hide loader after request is completed
    }
  };

  // Unapply job by Institute
  const UnApplyJobInstitute = async () => {
    console.log("unapply inst clicked");

    // setLoading(true); // Start loading
    try {
      const response = await axios.post(`/JobAction/UnApplyJobAsInstt`, {
        sessionId: sessionId,
        jobId: jobId,
        icsid: 0,
        icbid: 0,
      });
      console.log("UnApplyJob", response);
      toast.success(response.data.message);
      setShowAppliedModal(false);
      setCheckApplied(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      //   setLoading(false); // Stop loading
    }
  };

  // // ..............................................................................................................

  const handleBatch = (val) => {
    console.log("handle batch", val.value);
    setBatchId(val.value);
  };
  const handleClass = (val) => {
    console.log("handle Class", val.value);
    setClassId(val.value);
  };

  console.log("Batch List:", batchList);
  console.log("Class List:", ClassList);

  // ........................... Class API
  const GetCandidateClass = () => {
    const data = {
      sessionId: sessionId,
      name: "",
      type: "Class",
    };
	
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Class data", response);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setClassList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // ........................... BATCH API
  const GetCandidateBatch = () => {
    console.log("=========>");

    const data = {
      sessionId: sessionId,
      name: "",
      type: "Batch",
    };
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Batch data=====>", response.data.responseData);
        const res = response.data.responseData;
        console.log("res", res);

        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        console.log("data===>", data);

        setBatchList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (applyInstitute) {
      GetCandidateClass();
      GetCandidateBatch();
    }
  }, []);

  return (
    <>
      {checkApplied === true ? (
        <div className="appliedbtn mb-1">
          <Button
            className="mainBtn  appliedBtn apply-job"
            style={{ width: "100px" }}
            onClick={() => {
              handleShow();
            }}
          >
            <span className="default-text">Applied</span>
            <span className="hover-text">Withdraw</span>
          </Button>
        </div>
      ) : (
        <Button
          className="mainBtn apply-job"
          onClick={() => {
            handleApplyInstitute();
          }}
        >
          Apply Now
        </Button>
      )}

      {/*................................ Apply Institute Modal Start ...............................*/}
      <Modal show={applyInstitute} onHide={handleCloseApplyInstitute}>
        <Modal.Header closeButton>
          <Modal.Title>Apply for the Job</Modal.Title>
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>
            <Col md={12}>
              <Form.Group controlId="Name_Title">
                <Form.Label className="class-type">
                  Type
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
              </Form.Group>
              <div className="post-form-group">
                <Form.Group controlId="batchDropdown">
                  <Form.Control
                    as="select"
                    defaultValue="Select Type"
                    onChange={(e) => {
                      setSelectedType(e.target.value);
                    }}
                    placeholder="Select Type"
                  >
                    <option disabled>Select Type</option>
                    <option value="Batch">Batch</option>
                    <option value="Class">Class</option>
                  </Form.Control>
                </Form.Group>
              </div>
              {/* <div className="post-form-group">
                <label htmlFor="type">Batch</label>

                <ReactSelect
                  options={batchList}
                  onChange={handleBatch}
                  placeholder="Select Batch"
                  styles={customStyles}
                  classNamePrefix="react-select"
                  className="form-control"
                />
              </div> */}
            </Col>
          </Row>
          <div className="post-form-row">
            {selectedType === "Batch" && (
              <Col md={12}>
                <div className="post-form-group">
                  <label htmlFor="type">Batch</label>

                  <ReactSelect
                    options={batchList}
                    onChange={handleBatch}
                    placeholder="Select Batch"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                </div>
              </Col>
            )}
            {selectedType === "Class" && (
              <Col md={12}>
                <div className="post-form-group">
                  <label htmlFor="type">Class</label>
                  <ReactSelect
                    options={ClassList}
                    onChange={handleClass}
                    placeholder="Select Class"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                </div>
              </Col>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseApplyInstitute}>
            Close
          </Button>
          <Button
            className="apply-job"
            variant="primary"
            onClick={handleApplyJob}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/*.................................. Apply Institute Modal End ..................................*/}

      {/*.................................... UnApply Job Modal Start ................................*/}

      <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title> UnApply Job</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to UnApply Job</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={

              UnApplyJobInstitute
            }
            className="btn btn-danger me-2"
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      {/*.................................... UnApply Job Modal End ................................*/}
    </>
  );
};

export default ApplyjobAsInstitute;
